import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
//import LogoTitle from '../../assets/images/e_transparent.png'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import Logo from './Logo'

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = ['D','E','F','E','A','T',' ','B ','I','G',' ','T','E','C','H']
    const jobArray = ['w','i','t','h',' ','t','e', 'c','h']
    useEffect(() => {
        setTimeout(() => {
          setLetterClass('text-animate-hover')
        }, 5000)
      }, [])
    
    

    return ( 
        <div className="container home-page">
	    <div className="home-img"></div>
            <div className="text-zone">
                <h1>
                    <br /> 
                <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={14} />            
                <br />
                <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={28} />            
                </h1>
                <h2>Machine Learning | Data Engineering | Data Analytics</h2>
                <Link to="/contact" className="flat-button">CONTACT US</Link>
            </div>
            <Logo />
        </div>
    )
}

export default Home
